import React, { useState } from "react";
import { Form, Input, Button, Typography } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import { Link, useParams, useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";

const { Title, Text } = Typography;

const ResetPasswordPage = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await apiClient.post(`/auth/reset-password/${token}`, {
        password: values.password,
      });
      toast.success("Password reset successful");
      navigate("/login");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Error resetting password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex flex-col md:flex-row">
      <div className="hidden md:flex md:w-1/2 bg-[#1e5782] text-white items-center justify-center flex-col p-10">
        <h1 className="text-3xl font-semibold mb-4 text-center leading-snug">
          Create a New Password
        </h1>
        <p className="text-gray-200 text-center max-w-md text-sm leading-relaxed">
          Set a new secure password to continue using your Eye on Health account.
        </p>
        <div className="mt-8 w-16 h-[2px] bg-white/30 rounded-full"></div>
      </div>

      <div className="w-full md:w-1/2 flex items-center justify-center bg-white px-8 py-16">
        <div className="w-full max-w-md">
          <div className="md:hidden flex justify-center mb-8">
            <img
              src="/assets/logo.png"
              alt="Company Logo"
              className="w-36 h-12 object-contain"
            />
          </div>

          <Title level={3} className="text-center mb-3 text-gray-800">
            Set new password
          </Title>
          <Text className="block text-center text-gray-500 mb-8">
            Enter your new password below.
          </Text>

          <Form
            layout="vertical"
            onFinish={handleSubmit}
            requiredMark={false}
            className="space-y-4"
          >
            <Form.Item
              label="New Password"
              name="password"
              rules={[
                { required: true, message: "Please enter your new password" },
                { min: 4, message: "Password must be at least 4 characters" },
              ]}
            >
              <Input.Password
                prefix={<LockOutlined />}
                placeholder="Enter your new password"
                size="large"
              />
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="w-full bg-[#1e5782] hover:bg-[#184766] flex items-center justify-center mt-4"
                size="large"
                disabled={loading}
              >
                {loading ? (
                  <span className="flex space-x-1">
                    <span className="dot w-2 h-2 bg-white rounded-full animate-bounce [animation-delay:-0.3s]" />
                    <span className="dot w-2 h-2 bg-white rounded-full animate-bounce [animation-delay:-0.15s]" />
                    <span className="dot w-2 h-2 bg-white rounded-full animate-bounce" />
                  </span>
                ) : (
                  "Update Password"
                )}
              </Button>
            </Form.Item>

            <Text className="block text-center text-gray-600 mt-4">
              <Link to="/login" className="text-[#1e5782] font-medium hover:underline">
                Back to login
              </Link>
            </Text>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetPasswordPage;
